import styled from 'styled-components';
import { WarningIcon } from '../../../assets/svg/WarningIcon';

export const StyledWarningIcon = styled(WarningIcon)`
    transform: scale(2.5);
    margin-right: 16px;
`;
